omadapp.singletons.siscom = new(function() {
    var t = this
    var conf
    var $ = jQuery;
    var POST = "post";
    var GET = "get";
    t.inicializado = false
    t.inicializar = inicializar
    t.cargar = cargar

    t.getConfig = getConfig
    
    var csrf,header

    function inicializar(obj,callback) {
        if (omadapp.App.config.disableSisCom) {
            callback()
            return
        }
        conf = JSON.parse(JSON.stringify(obj))
        t.inicializado = true
         callback()
      
    }


    function getConfig() {
        return conf
    }

    function cargar(url, metodo, data, silencioso, callback, dataType) {
    	if (!t.inicializado) {
    		console.error("siscom no inicializado")
    		return
    	}

    	trace ("cargar "+url)
        var xx = new Date()
        metodo = metodo || GET
        dataType = dataType || "json"
        data = data || {}

        if (!silencioso) {
            //to-do
            //mostrarLoading()
        }


        var confAjax = {
            url: url,
            dataType: dataType,
            headers:header,
            data: data,
            type: metodo,
            error: function(jqXHR, textStatus, errorThrown) {
                console.warn(this)
                console.warn ("error en la llamada ---")

                console.warn(jqXHR)
                if (callback) callback(jqXHR)
            },

            success: function(a, b, c) {
                var arj = a.responseJSON
                trace ("success")
                trace (a)
                // to-do:
                // ocultarLoading()
                if (callback) callback(a, b, c)

            }
        }
        trace (confAjax)
        trace (data)
        var objAjax = $.ajax(confAjax);
        return objAjax
    }

})
